var map = {
	"./logo-menu-audience.png": 1091,
	"./logo-menu-data.png": 1092,
	"./logo-menu-delivery.png": 1093,
	"./logo-menu-journey.png": 1094,
	"./logo-menu-reports.png": 1095,
	"./logo-menu-settings.png": 1096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1090;